module.exports = __webpack_public_path__ + "static/img/logo2.51155ae3.jpg";